"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICATION_STATUS_OPTIONS = exports.STATUS_BADGE_CLASS = exports.APPLICATION_STATUS_LABELS = void 0;
exports.APPLICATION_STATUS_LABELS = {
    PENDING: '대기',
    RECEIVED: '접수',
    DEPOSIT_WAIT: '계약금대기',
    BALANCE_WAIT: '잔금대기',
    COMPLETED: '계약완료',
    CANCELLED: '취소',
};
exports.STATUS_BADGE_CLASS = {
    PENDING: 'badge-warning',
    RECEIVED: 'badge-info',
    DEPOSIT_WAIT: 'badge-secondary',
    BALANCE_WAIT: 'badge-secondary',
    COMPLETED: 'badge-success',
    CANCELLED: 'badge-error',
};
exports.APPLICATION_STATUS_OPTIONS = [
    { value: 'PENDING', label: '대기' },
    { value: 'RECEIVED', label: '접수' },
    { value: 'DEPOSIT_WAIT', label: '계약금대기' },
    { value: 'BALANCE_WAIT', label: '잔금대기' },
    { value: 'COMPLETED', label: '계약완료' },
    { value: 'CANCELLED', label: '취소' },
];
